<template>
  <p v-if="isVisible" class="l-pl-1">
    <span class="c-text--main c-text--bold"
      >{{ gaTypeLabel }}データを表示中</span
    >
    <span v-if="isAuthority"
      >（{{ anotherGaTypeLabel }}データに切り替える場合は<router-link
        :to="{ name: 'configProject', params: { projectId: project.id } }"
        >こちら</router-link
      >）</span
    >
  </p>
</template>

<script>
export default {
  props: {
    gaType: {
      type: String,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  computed: {
    anotherGaTypeLabel() {
      return this.gaType === 'ua' ? 'GA4' : 'UA';
    },
    gaTypeLabel() {
      return this.gaType === 'ua' ? 'UA' : 'GA4';
    },
    isAuthority() {
      return this.$store.state.user.me.organization.isAuthority;
    },
    isVisible() {
      return this.project.ga4AccountId && this.project.gaAccountId;
    }
  }
};
</script>
